import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontSize, FontSizes, fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

import StarsImage from 'icons/five-stars.svg';

export const Heading = styled.h1`
	${fontSize(FontSizes.xl)};
	color: ${palette('gray7')};
	${fontWeight(FontWeights.Demi)};
`;

export const Subheading = styled.h2`
	${fontSize(FontSizes.lg)};
	color: ${palette('gray6')};
	${fontWeight(FontWeights.Light)};
	margin-bottom: 8px;
`;

export const FiveStarsContainer = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin-bottom: 32px;

	${minWidth('desktop')} {
		flex-direction: row;
	}
`;

export const StarsText = styled.p`
	${fontWeight(FontWeights.Medium)};
	margin-bottom: 4px;
`;

export const Stars = styled(StarsImage)`
	margin-left: 8px;
`;
